import { Activity } from "lucide-react";
import MarketTrendsBoard from "../components/MarketTrendsBoard";

// Full-page /trends route — same board that appears on the Dashboard, just
// with a page header + the "Updated Xm ago" footer.
export default function MarketTrends() {
  return (
    <div className="space-y-6" data-testid="market-trends-page">
      <div>
        <div className="text-xs uppercase tracking-widest text-muted-foreground">Market Trends</div>
        <h1 className="font-display text-3xl md:text-4xl font-bold mt-1 flex items-center gap-3">
          <Activity className="w-7 h-7 md:w-8 md:h-8 opacity-70" />
          What's moving today
        </h1>
        <div className="text-sm text-muted-foreground mt-1">Live gainers, losers, dollar-volume leaders, options flow and sector rotation.</div>
      </div>
      <MarketTrendsBoard compact={false} />
    </div>
  );
}
